
    import Vue from "vue";
    import Component from "vue-class-component";
    import { StateChanger } from "vue-infinite-loading";
    import { Watch } from "vue-property-decorator";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import ColourSwatch from "@/vue/components/ColourSwatch.vue";
    import ClientDialogue from "@/vue/components/ClientDialogue.vue";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import { ClientSearchParameters } from "@/model/ClientSearchParameters";
    import { IClient, Client } from "@/model/Client";
    import { BannerOption, BriefingProgressOption } from "@/model/Enums";

    interface ISearchResponse {
        list: Array<IClient>;
        count: number;
    }

    @Component({
        components: { ApiButton, ClientDialogue, ColourSwatch }
    })
    export default class Clients extends Vue {

        //
        // -- properties
        //

        clientHeaders = [
            { text: "Name", value: "name", sortable: false }
        ];

        infiniteId: number = +new Date();
        searchParameters = new ClientSearchParameters();
        resultCount: string = "-";
        clientList: Array<Client> = [];

        bannerOptionText(client: Client) {
            return Utils.camelCaseAddSpaces(BannerOption[client.bannerOption]);
        }

        progressOptionText(client: Client) {
            return Utils.camelCaseAddSpaces(BriefingProgressOption[client.briefingProgressOption]);
        }

        //
        // -- Watchers
        //

        private debouncedRefreshSearch = Utils.debounce(this.refreshSearch, 200);

        @Watch("searchParameters.searchText")
        private onSearchTextchanged(): void {
            this.debouncedRefreshSearch();
        }

        //
        // -- methods
        //

        logoSource(client: Client): string {
            return client?.logoResource?.sourceUrl ?? require("@/images/missing.png");
        }

        logoRightSource(client: Client): string {
            return client?.logoRightResource?.sourceUrl ?? require("@/images/missing.png");
        }

        editNew(): void {
            const dialog: ClientDialogue = this.$refs.clientDialogue as ClientDialogue;
            dialog.show(Utils.emptyGuidValue);
        }

        edit(client: Client): void {
            const dialog: ClientDialogue = this.$refs.clientDialogue as ClientDialogue;
            dialog.show(client.id);
        }

        refreshSearch(): void {
            this.resultCount = "-";
            this.clientList = [];
            this.searchParameters.pageNumber = 1;
            this.infiniteId += 1;
        }

        async infiniteLoadingHandler(stateChanger: StateChanger): Promise<void> {
            const response: ISearchResponse = await ApiClient.post("/Api/Client/Search", this.searchParameters);
            if(this.searchParameters.pageNumber === 1) {
                this.resultCount = String(response.count);
            }
            if (response.list.length) {
                this.clientList.push(...response.list.map((c: IClient) => new Client(c)));
                this.searchParameters.pageNumber += 1;
                stateChanger.loaded();
            }
            else {
                stateChanger.complete();
            }
        }
    }
